import CampusClient from '@/api/CampusClient';

export default class CustomUserTags {
    constructor() {
        this.schoolId = null;
        this.loading = false;
        this.error = null;
        this.customTags = { tags: []};
        this.pageToken = null;
    }

    async initialize($http, schoolId) {
        this.campusClient = new CampusClient($http);
        this.schoolId = schoolId;

        await this.fetch();
    }

    hasTags() {
        return this.customTags.tags.length
    }

    async fetch() {
        try {
            this.loading = true;

            this.customTags = await this.campusClient.getDistinctUserTags(
                this.schoolId,
                //this.pageToken
            );
            this.loading = false;
        } catch (error) {
            this.error = error;
        }
    }
}
